import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=671a1a87&"
import script from "./apply.vue?vue&type=script&lang=js&"
export * from "./apply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports